// Module
var code = "<div> <div class=\"name\">{{ friendly }} Errors</div> <template v-if=\"editing == true\"> <div class=\"top6\"> <checkbox-field label=\"Has Errors\" v-model=\"filter.hasErrors\"></checkbox-field> </div> </template> </div> ";
// Exports
export default code;